import {MuiDataGrid} from "@leap4/frontend";

import {Link} from "react-router-dom";
import {urlService} from "../../routing/urlsService";
import * as React from "react";
import {TableCellWithCompare} from "../../shared/TableCellWithComparison/TableCellWithCompare";
import {EntitiesProperties} from "../../../utils/enums";
import {ScrapingUtils} from "../../../utils/scraping.utils";
import PercentCell from "../../shared/PercentCell/PercentCell";

type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

enum PartnerType {
    supply = "supply",
    demand = "demand"
}

const align = 'left'
const {
    PROFIT,
    PROFIT_PERCENT,
    IMPRESSIONS,
    COST,
    FILL_RATE,
    REQUESTS,
    REVENUE,
    NET_COST,
    NET_PROFIT,
    NET_REVENUE,
    CPM,
    RPM,
    COMPLETION,
    VCR,
    INCOMING_REQUESTS,
    AD_FILL_RATE,
    SERVICE_COST,
} = EntitiesProperties.NUMERIC.ALL

const {
    DEMAND_TAG,
    SUPPLY_TAG,
    DATAPOINT,
    ADSERVER,
    SUPPLY_PARTNER,
    DEMAND_PARTNER,
    NAME,
    CAMPAIGN_ID,
    PUBLISHER_IMPRESSIONS,
    IMPRESSIONS_DIFFERENCE,
    PUBLISHER_REVENUE,
    REVENUE_DIFFERENCE,
} = EntitiesProperties.NOT_NUMERIC

export const generateColumn = (field, compareData, tableCellType = null): GridColDef => {
    switch (field) {
        case SUPPLY_TAG:
            return _generateSupplyTag();
        case DEMAND_TAG:
            return _generateDemandTag();
        case     PROFIT:
            return _generateProfit(compareData, tableCellType);
        case PROFIT_PERCENT:
            return _generateProfitPercent(compareData, tableCellType);
        case NET_PROFIT:
            return _generateNetProfit(compareData, tableCellType);
        case NET_REVENUE:
            return _generateNetRevenue(compareData, tableCellType);
        case NET_COST:
            return _generateNetCost(compareData, tableCellType);
        case SERVICE_COST:
            return _generateServiceCost(compareData, tableCellType);
        case FILL_RATE:
            return _generateFillRate(compareData, tableCellType);
        case IMPRESSIONS:
            return _generateImpressions(compareData, tableCellType);
        case REVENUE:
            return _generateRevenue(compareData, tableCellType);
        case COST:
            return _generateCost(compareData, tableCellType);
        case CPM:
            return _generateCPM(compareData, tableCellType);
        case RPM:
            return _generateRPM(compareData, tableCellType);
        case VCR:
            return _generateVCR(compareData, tableCellType);
        case REQUESTS:
            return _generateRequests(compareData, tableCellType);
        case ADSERVER:
            return _generateAdServer();
        case DATAPOINT:
            return _generateDataPoint();
        case SUPPLY_PARTNER:
            return _generateSupplyPartner();
        case DEMAND_PARTNER:
            return _generateDemandPartner();
        case NAME:
            return _generateName();
        case CAMPAIGN_ID:
            return _generateCampaignId();
        case PUBLISHER_IMPRESSIONS:
            return _generatePublisherImpressions();
        case IMPRESSIONS_DIFFERENCE:
            return _generateImpressionsDifference();
        case PUBLISHER_REVENUE:
            return _generatePublisherRevenue();
        case REVENUE_DIFFERENCE:
            return _generateRevenueDifference();
        case COMPLETION:
            return _generateCompletion(compareData, tableCellType);

            case INCOMING_REQUESTS:
            return _generateIncomingRequests(compareData, tableCellType);

        case AD_FILL_RATE:
            return _generateAdFillRate(compareData,tableCellType)
    }

    return {} as GridColDef
}

const _generateRevenueDifference = () =>{
    return             {
        field: REVENUE_DIFFERENCE,
        headerName: '',
        type: 'number',
        width: 150,
        align,
        headerAlign: "left",
        renderCell: (params) => {
            return params.value ? <PercentCell percent={params.value as number}/> : ""
        }
    } as GridColDef
}

const _generatePublisherRevenue = () =>{
    return             {
        field: PUBLISHER_REVENUE,
        headerName: 'Publisher Revenue',
        type: 'number',
        width: 200,
        align,
        headerAlign: "left",
        renderCell: (params) => {
            return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
        }
    } as GridColDef
}

const _generateImpressionsDifference = () =>{
    return             {
        field: IMPRESSIONS_DIFFERENCE,
        headerName: '',
        type: 'number',
        width: 150,
        align,
        headerAlign: "left",
        renderCell: (params) => {
            return params.value ? <PercentCell percent={params.value as number}/> : ""
        }
    } as GridColDef
}

const _generatePublisherImpressions = () =>{
    return {
        field: PUBLISHER_IMPRESSIONS,
        headerName: 'Publisher Impressions',
        type: 'number',
        width: 200,
        align,
        headerAlign: "left",
        renderCell: (params) => {
            return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
        }
    } as GridColDef
}

const _generateCampaignId = () =>{
   return {
        field: 'campaignId',
            headerName: 'Campaign ID',
        width: 150,
    }
}

const _generateName = () =>{
    return {
        field: 'name',
        headerName: 'Name',
        width: 500,
        renderCell: (params: GridRenderCellParams) => {
            return <Link to={urlService.adServerTag((params as any).id, true)}><strong
            >{(params as any).formattedValue}</strong></Link>
        }
    }
}

const _generateDemandPartner = () => {
    return {
        field: DEMAND_PARTNER,
        headerName: 'Demand Partner',
        hideable: false,
        width: 250,
        renderCell: (params: GridRenderCellParams) => {
            return <Link
                to={urlService.partnerOverview(getPartnerId(PartnerType.demand, params.row.id), true)}><strong
            >{params.value}</strong></Link>
        }
    }
}

const _generateSupplyPartner = () => {
    return {
        field: SUPPLY_PARTNER,
        headerName: 'Supply Partner',
        hideable: false,
        width: 250,
        renderCell: (params: GridRenderCellParams) => {
            return <Link
                to={urlService.partnerOverview(getPartnerId(PartnerType.supply, params.row.id), true)}><strong
            >{params.value}</strong></Link>
        }
    }
}

const _generateDataPoint = () => {
    return {
        field: 'dataPoint',
        headerName: 'DataPoint',
        width: 150,
        renderCell: (params: GridRenderCellParams) => {
            return <Link to={urlService.dataPointOverview(params.value._id, true)}><strong
            >{params.value}</strong></Link>
        },
        valueFormatter: (value: any) => value || 'Un-Named'
    } as GridColDef
}

const _generateAdServer = () => {
    return {
        field: 'adServer',
        headerName: 'Ad Server',
        width: 150,
        renderCell: (params: GridRenderCellParams) => {
            return <Link to={urlService.adServerOverview(params.value._id, true)}><strong
            >{params.value}</strong></Link>
        },
        valueFormatter: (value: any) => value || 'Un-Named'
    } as GridColDef
}


const _generateRequests = (compareData, tableCellType) => {
    return {
        field: REQUESTS,
        headerName: 'Ad Requests',
        type: 'number',
        width: 150,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={REQUESTS} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateCPM = (compareData, tableCellType) => {
    return {
        field: CPM,
        headerName: 'CPM',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={CPM} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateRPM = (compareData, tableCellType) => {
    return {
        field: RPM,
        headerName: 'RPM',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={RPM} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateVCR = (compareData, tableCellType) => {
    return {
        field: VCR,
        headerName: 'VCR',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={VCR} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateCompletion = (compareData, tableCellType) => {
    return {
        field: COMPLETION,
        headerName: 'Completion',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={COMPLETION} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef

}
const _generateIncomingRequests = (compareData, tableCellType) => {
    return {
        field: INCOMING_REQUESTS,
        headerName: 'Incoming Requests',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={INCOMING_REQUESTS} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateCost = (compareData, tableCellType = null) => {
    return {
        field: COST,
        headerName: 'Cost',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={COST} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateRevenue = (compareData, tableCellType) => {
    return {
        field: REVENUE,
        headerName: 'Revenue',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={REVENUE} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateImpressions = (compareData, tableCellType) => {
    return {
        field: IMPRESSIONS,
        headerName: 'Impressions',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={IMPRESSIONS} compareData={compareData} selectedData={params} tableCellType={tableCellType}/>
        }
    } as GridColDef
}

const _generateFillRate = (compareData, tableCellType) => {
    return {
        field: FILL_RATE,
        headerName: 'Fill Rate',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={FILL_RATE} compareData={compareData} selectedData={params}/>
        }
    } as GridColDef
}
const _generateAdFillRate = (compareData, tableCellType) => {
    return {
        field: AD_FILL_RATE,
        headerName: 'Ad Fill Rate',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={AD_FILL_RATE} compareData={compareData} selectedData={params}/>
        }
    } as GridColDef
}

const _generateNetCost = (compareData, tableCellType) => {
    return {
        field: NET_COST,
        headerName: 'Net Cost',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={NET_COST} compareData={compareData}
                                         selectedData={params}/>
        }
    } as GridColDef
}

const _generateServiceCost = (compareData, tableCellType) => {
    return {
        field: SERVICE_COST,
        headerName: 'Serving Cost',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={NET_COST} compareData={compareData}
                                         selectedData={params}/>
        }
    } as GridColDef
}

const _generateNetRevenue = (compareData, tableCellType) => {
    return {
        field: NET_REVENUE,
        headerName: 'Net Revenue',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={NET_REVENUE} compareData={compareData}
                                         selectedData={params}/>
        }
    } as GridColDef
}
const _generateNetProfit = (compareData, tableCellType) => {
    return {
        field: NET_PROFIT,
        headerName: 'Net Profit',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare metricEnum={NET_PROFIT} compareData={compareData} tableCellType={tableCellType}
                                         selectedData={params}/>
        }
    } as GridColDef
}

const _generateSupplyTag = () => {
    return {
        field: 'supplyTag',
        headerName: 'Supply Tag',
        hideable: false,
        width: 450,
        renderCell: (params: GridRenderCellParams) => {
            return <Link to={urlService.adServerTag(params.row.id.slice(24), true)}><strong
            >{params.value}</strong></Link>
        },
        valueFormatter: (value: any) => value || 'Un-Named'
    } as GridColDef
}

const _generateDemandTag = () => {
    return {
        field: 'demandTag',
        hideable: false,
        headerName: 'Demand Tag',
        width: 330,
        renderCell: (params: GridRenderCellParams) => {
            return <Link to={urlService.adServerTag(params.row.id.slice(0,24), true)}><strong
            >{params.value}</strong></Link>
        },
        valueFormatter: (value: any) => value || 'Un-Named'
    } as GridColDef
}

const _generateProfit = (compareData, tableCellType) => {
    return {
        field: PROFIT,
        headerName: 'Profit',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={PROFIT} compareData={compareData} selectedData={params}/>
        }
    } as GridColDef
}

const _generateProfitPercent = (compareData, tableCellType) => {
    return {
        field: PROFIT_PERCENT,
        headerName: 'Profit Percent',
        type: 'number',
        width: 130,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return <TableCellWithCompare tableCellType={tableCellType} metricEnum={PROFIT_PERCENT} compareData={compareData}
                                         selectedData={params}/>
        }
    } as GridColDef
}

export const getPartnerId = (partnerType, rowId) => {
    return partnerType === PartnerType.demand ?
        rowId.slice(0, 24) :
        rowId.slice(24)
}